import { render, staticRenderFns } from "./NewProjectGoals.vue?vue&type=template&id=0054b388&scoped=true&"
import script from "./NewProjectGoals.vue?vue&type=script&lang=js&"
export * from "./NewProjectGoals.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectGoals.vue?vue&type=style&index=0&id=0054b388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054b388",
  null
  
)

export default component.exports